import { IItemPreguntaCheckpointDTO, ItemPreguntaCheckpointDTO } from "./ItemPreguntaCheckpoint.DTO";
import { PreguntasTipoEnum } from "@shared/enums";
import { Nilable } from "@shared/utils";

export interface IPreguntaCheckpointDTO {
    id: number;
    items: IItemPreguntaCheckpointDTO[];
    text: string;
    type: string;
}

export class PreguntaCheckpointDTO {
    public id = 0;
    public items: ItemPreguntaCheckpointDTO[] = [];
    public texto = "";
    public tipo = PreguntasTipoEnum.SINGLE_CHOICE;

    constructor(json: Nilable<Partial<IPreguntaCheckpointDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPreguntaCheckpointDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.items != null) {
            this.items = json.items.map(item => new ItemPreguntaCheckpointDTO(item));
        }
        if (json.text != null) {
            this.texto = json.text;
        }
        if (json.type != null) {
            this.tipo = PreguntasTipoEnum[json.type];
        }
    }
}
